export default "__VITE_ASSET__Dke9Iup2__"